import {Component, computed, inject, input, Optional, SkipSelf} from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  FormGroupDirective,
  FormGroupName,
  ReactiveFormsModule,
} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MultiSelectModule} from 'primeng/multiselect';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {DirectusTranslatedItem} from '@frontend/directus';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {of, startWith, switchMap} from 'rxjs';

@Component({
  selector: 'app-form-field-multiselect',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MultiSelectModule,
    InputTextModule,
    TranslocoPipe,
    TranslateDirectusPipe,
  ],
  templateUrl: './form-field-multiselect.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (parentGroupName: FormGroupName, parentFormDir: FormGroupDirective) =>
        parentGroupName ?? parentFormDir,
      deps: [
        [new Optional(), new SkipSelf(), FormGroupName],
        [new Optional(), new SkipSelf(), FormGroupDirective],
      ],
    },
  ],
})
export class FormFieldMultiselectComponent {
  id = input.required<string>();
  fieldName = input.required<string>();
  label = input.required<string>();
  placeholder = input<string>('');
  selectTranslatedOptions = input<DirectusTranslatedItem[]>([]);
  isReadOnly = input<boolean>(false);
  isRequired = input<boolean>(false);
  smallLabel = input<boolean>(false);

  @Optional() private readonly controlContainer = inject(ControlContainer);

  get form(): FormGroup {
    return this.controlContainer?.control as FormGroup;
  }

  readonly formControlValue = toSignal(
    toObservable(this.fieldName).pipe(
      switchMap((name) => {
        const ctrl = this.form?.get(name);
        return ctrl ? ctrl.valueChanges.pipe(startWith(ctrl.value)) : of(null);
      }),
    ),
  );

  readonly hasFilterText = computed(() => {
    const options = this.selectTranslatedOptions();
    return !!options?.[0]?.filterText;
  });
}
